module.exports = __webpack_public_path__ + "static/media/person.520e705f.svg";